import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'

export interface DevEvidenceState {
  isModalOpen: boolean
  isSupplymentRequired: boolean
  isSupplymentUploaded: boolean
  evidenceGroupId: string
  evidenceId: string
  fileName: string
  isRefreshRequired?: boolean
  isLoading: boolean
  supplementAccountName?: string
  supplementAccountId?: string  
}

export const initialState: DevEvidenceState = {
  isModalOpen: false,
  isSupplymentRequired: false,
  isSupplymentUploaded: false,
  evidenceGroupId: '',
  evidenceId: '',
  fileName: '',
  isRefreshRequired: false,
  isLoading: false,
  supplementAccountName: undefined,
  supplementAccountId: undefined,
}

const DeveloperEvidenceSlice = createSlice({
  name: 'DeveloperEvidence',
  initialState,
  reducers: {
    setEvidence(state: DevEvidenceState, action: PayloadAction<any>) {
      const { isModalOpen, evidenceId, fileName, isRefreshRequired } = action.payload
      state.isModalOpen = isModalOpen
      state.evidenceId = evidenceId
      state.fileName = fileName
      state.isRefreshRequired = isRefreshRequired
    },
    setSupplementEvidence(state: DevEvidenceState, action: PayloadAction<any>) {
      const { isSupplymentRequired, evidenceGroupId, isSupplymentUploaded, supplementAccountName, supplementAccountId } = action.payload
      state.isSupplymentRequired = isSupplymentRequired
      state.evidenceGroupId = evidenceGroupId
      state.isSupplymentUploaded = isSupplymentUploaded
      state.supplementAccountName = supplementAccountName
      state.supplementAccountId = supplementAccountId
    },
    setIsModalOpen: (
      state: DevEvidenceState,
      action: PayloadAction<boolean>,
    ) => {
      state.isModalOpen = action.payload
    },
    setIsLoading: (
      state: DevEvidenceState,
      action: PayloadAction<boolean>,
    ) => {
      state.isLoading = action.payload
    }
  },
})

export const { setEvidence, setSupplementEvidence, setIsModalOpen, setIsLoading } = DeveloperEvidenceSlice.actions
export default DeveloperEvidenceSlice.reducer
